import { useState, useEffect } from "react"; 
import { useLocation } from "react-router-dom";
import { useTheme } from "./core/contexts/ThemeProvider";
import { useStore } from "./core/hooks/useStore";
import Loader from "./ui/components/Loader";
import AppRoutes from "./routes";
import { toast, Toaster } from "sonner";

function App() {
  const appTitle = "PlugQuest Admin";
  const location = useLocation();
  const { initializeTheme, isDark } = useTheme();
  const { checkAuthStatus, initializationComplete } = useStore();
  const [isAppInitialized, setIsAppInitialized] = useState(false);

  // Single initialization effect
  useEffect(() => {
    const initializeApp = async () => {
      try {
        await Promise.all([
          initializeTheme(),
          checkAuthStatus()
        ]);
      } catch (error) {
        console.error("Failed to initialize app:", error);
      } finally {
        setIsAppInitialized(true);
      }
    };

    initializeApp();
  }, [checkAuthStatus, initializeTheme]);

  // Route-based effects
  useEffect(() => {
    document.title = appTitle;
    window.scrollTo(0, 0);
  }, [location]);

  // Network status
    useEffect(() => {
    const handleOnline = () => {
      toast.success("Connection restored", {id: "online", description: "You are back online", duration: 5000,})
    };

    const handleOffline = () => {
      toast.error("Connection Error", {id: "offline", description: "No internet connection detected", duration: 5000, })
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []); 

  if (!isAppInitialized || !initializationComplete) {
    return <Loader />;
  }

  return (
    <>
      <Toaster 
        richColors 
        position="top-right" 
        theme={isDark ? "dark" : "light"}
      />

      <AppRoutes />
    </>
  );
}

export default App;